import NumberFormat from 'react-number-format';

type Props = {
    value: number;
};

const PercentageDisplay = ({ value }: Props): JSX.Element => {
    return <NumberFormat displayType="text" suffix="%" decimalScale={3} value={value} />;
};

export default PercentageDisplay;
